module.exports = __webpack_public_path__ + "img/plus_01.dddc83b0.png";